import { useEffect, useState } from 'react';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { useGetColumns } from '../hooks/useGetColumns';
import { useGetFilters } from '../hooks/useGetFilters';
import { useGetRows } from '../hooks/useGetRows';
import { BuscarPacienteFilters } from './BuscarPacienteFilters';

export const BuscarPacienteContent = () => {
    const [isRefetchRequired, setIsRefetchRequired] = useState(true);

    const {
        filters,
        handleChangeFilters,
    } = useGetFilters();

    const {
        rows,
        setRows,
        loading,
        totalCount,
        handleSearch
    } = useGetRows(filters, setIsRefetchRequired);

    const columns = useGetColumns();

    useEffect(() => {
        handleSearch(true);
    }, []);

    const handleFilters = (name, value) => {
        handleChangeFilters(name, value);
        setRows([]);
        setIsRefetchRequired(true);
    }

    return (
        <div>
            <BuscarPacienteFilters
                filters={filters}
                handleChangeFilters={handleFilters}
                handleSearch={handleSearch}
                disableFilters={loading}
            />

            <DataGridGenerico
                columns={columns}
                rows={rows}
                totalCount={totalCount}
                loading={loading}
                toolbar={false}
                localeText={{
                    noRowsLabel: isRefetchRequired ?
                        'Haz click en "Buscar" para aplicar los nuevos filtros' :
                        "Sin filas"
                }}
                entityId='idPaciente'
            />
        </div>
    );
}